import axios from 'axios';
import {QueryClient} from '@tanstack/react-query';
import {getRuntimeConfig} from '../config/runtime-config';
import {updatePublicApiBaseUrl} from './publicApi';

// Функция для получения baseURL с учетом runtime конфига
const getApiBaseUrl = () => {
  const config = getRuntimeConfig();
  return config.apiUrl;
};

const getKratosBaseUrl = () => {
  const config = getRuntimeConfig();
  return config.kratosUrl;
};

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Экземпляр для Kratos
export const kratosApi = axios.create({
  baseURL: getKratosBaseUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Функция для обновления baseURL после загрузки конфига
export const updateApiBaseUrls = () => {
  api.defaults.baseURL = getApiBaseUrl();
  kratosApi.defaults.baseURL = getKratosBaseUrl();
  updatePublicApiBaseUrl();
};

// Переменная для отслеживания перенаправления, чтобы избежать множественных редиректов
let isRedirecting = false;

// Функция для сброса флага перенаправления (может быть вызвана извне)
export const resetRedirectingFlag = () => {
  isRedirecting = false;
};

// Настройка interceptors для обработки ошибок авторизации
export const setupApiInterceptors = (queryClient?: QueryClient) => {
  // Сбрасываем флаг при инициализации, если мы уже на странице авторизации
  if (typeof window !== 'undefined') {
    const currentPath = window.location.pathname;
    if (currentPath === '/auth') {
      isRedirecting = false;
    }
  }

  // Response interceptor для основного API
  api.interceptors.response.use(
    (response) => {
      // При успешном ответе сбрасываем флаг, если он был установлен
      if (isRedirecting) {
        isRedirecting = false;
      }
      return response;
    },
    (error) => {
      if (error.response) {
        const status = error.response.status;

        // При 401 или 403 ошибке перенаправляем на страницу авторизации
        if ((status === 401 || status === 403) && !isRedirecting) {
          // Проверяем, что мы не на странице авторизации уже
          const currentPath = window.location.pathname;
          if (currentPath !== '/auth') {
            isRedirecting = true;

            // Очищаем кэш React Query для сессии, если queryClient доступен
            if (queryClient) {
              queryClient.removeQueries({queryKey: ['session']});
            }

            // Перенаправляем на страницу авторизации
            window.location.href = '/auth';
            return Promise.reject(error);
          } else {
            // Если уже на странице авторизации, сбрасываем флаг
            isRedirecting = false;
          }
        }
      }

      return Promise.reject(error);
    },
  );
};
